import React from 'react';
import Container from 'atomic/container';
import MenuDesktop from 'modules/shared/layout/menu/menu-desktop/menu-desktop';
import CustomTopDesktop from 'modules/shared/layout/menu/components/custom-top/custom-top-desktop';

import './top-bar.scss';

const TopBar: React.FC = () => (
    <div className="top-bar" id="top-bar">
        <Container className="top-bar__container">
            <MenuDesktop />
            <CustomTopDesktop />
        </Container>
    </div>
);

export default TopBar;
